import fetch from 'isomorphic-fetch';
import {API2_URL,  SURVEYS_REQUEST, SURVEYS_COMPLETE, SURVEYS_TYPES_REQUEST, SURVEYS_FETCH, SURVEYS_FETCH_LIST,
	SURVEYS_FETCH_TYPES, SURVEYS_EDIT, /*SURVEYS_QUESTIONS_EDIT,*/ SURVEYS_CLEAR, SURVEYS_FAIL} from "../store/config";
import { newNotification } from "./notifications";
import { history } from "../store/store";
import _ from "lodash";
import {sessionService} from "redux-react-session";

export const surveysShow = (page = 1) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(surveysRequest());
				return fetch((`${API2_URL}/surveys?page=${page}`), options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(surveysData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
							return dispatch(surveysFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
						}
					)
			})
	}
}

export const fetchSurveysList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(surveysRequest());
				return fetch((`${API2_URL}/surveys?per_page=all`), options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(surveysListData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
							return dispatch(surveysFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
						}
					)
			})
	}
}

export const surveysFetchTypes = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(surveysTypesRequest());
				return fetch((`${API2_URL}/surveys/types`), options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(surveysTypes(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
							return dispatch(surveysFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
						}
					)
			})
	}
}

export const fetchSurvey = (id) => (dispatch) => {
	dispatch(surveysRequest());
	dispatch(surveysClear());
	return dispatch(surveysEdit(id))
		.then((survey) => {
			if(!_.isEmpty(survey.payload)){
				return dispatch(surveysComplete())
			}
		})
}

const surveysEdit = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch((`${API2_URL}/surveys/${id}`), options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(surveysEditData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
							return dispatch(surveysFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
						}
					)
			})
	}
}

export const surveySave = (values) => (dispatch) => {
	if(!_.isEmpty(values.children_questions)){
		dispatch(surveysRequest());
		return dispatch(surveyEditSave(values))
			.then((surveys) => {
				if(!_.isEmpty(surveys.payload)){
					return dispatch(surveysComplete())
					/*return dispatch(surveyQuestionsEditSave(values, questions, surveys.payload.id))
						.then((questions) => {
							if(!_.isEmpty(questions.payload)){
								if(values.id){
									return dispatch(surveysComplete())
								}
							}
						})*/
				}
			})
	}else {
		dispatch(newNotification({title: "¡Oh no!", content: "La Encuesta debe de contener minimo una pregunta", type: "danger"}))
		return dispatch(surveysFail("La Encuesta debe de contener minimo una pregunta"))
	}
}

const surveyEditSave = (values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(values)
				};

				return fetch((`${API2_URL}/surveys${values.id ? `/${values.id}?_method=PUT`:''}`), options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.message:"La Encuesta se ha guardado correctamente", type: "success"}));
							if(_.isEmpty(values.id)){
								history.push(`/encuestas/editar/${json.data.id}`);
							}
							return dispatch(surveysEditData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
							return dispatch(surveysFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
						}
					)
			})
	}
}

export const surveyDelete = (id) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'Delete'
				};

				dispatch(surveysRequest());
				return fetch((`${API2_URL}/surveys/${id}`), options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: json.message ? json.messaje:"La Encuesta se ha borrado correctamente", type: "success"}));
							dispatch(surveysComplete());
							dispatch(surveysShow());
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}))
							return dispatch(surveysFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
						}
					)
			})
	}
}

const surveysRequest = () => {
	return {
		type: SURVEYS_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const surveysTypesRequest = () => {
	return {
		type: SURVEYS_TYPES_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const surveysData = (json) => {
	return {
		type: SURVEYS_FETCH,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	};
}

const surveysListData = (json) => {
	return {
		type: SURVEYS_FETCH_LIST,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	};
}

const surveysTypes = (json) => {
	return {
		type: SURVEYS_FETCH_TYPES,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	};
}

const surveysEditData = (json) => {
	return {
		type: SURVEYS_EDIT,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	};
}

/*const surveysQuestionsEditData = (json) => {
	return {
		type: SURVEYS_QUESTIONS_EDIT,
		payload: json,
		timestamp: Date.now()
	};
}*/

const surveysClear = () => {
	return {
		type: SURVEYS_CLEAR,
		payload: {
			questions:[]
		},
		timestamp: Date.now()
	}
}

const surveysComplete = () => {
	return {
		type: SURVEYS_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

const surveysFail = (error) => {
	return {
		type: SURVEYS_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}




// WEBPACK FOOTER //
// ./src/actions/surveys.js